import styled, { keyframes } from 'styled-components'
import { rem } from 'polished'
import { getImageUrl } from 'lib/image/imageUtils'

const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(var(--float-y)) rotate(var(--float-rotate));
  }
`

const FloatingImagesContainer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
`

const BaseFloatingImage = styled.div`
  position: absolute;
  border-radius: ${rem(12)};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadow.bottom.medium};
  animation-name: ${floatAnimation};
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
`

const ImageElement = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const FloatingImageTopLeft = styled(BaseFloatingImage)`
  width: ${rem(120)};
  height: ${rem(120)};
  top: ${rem(17)};
  left: ${rem(118)};
  --float-y: ${rem(-12)};
  --float-rotate: -2deg;
  animation-duration: 3.8s;
  animation-delay: 0.3s;
`

const FloatingImageLeft = styled(BaseFloatingImage)`
  width: ${rem(229)};
  height: ${rem(229)};
  top: calc(50% - ${rem(229 / 2)});
  left: ${rem(-39)};
  --float-y: ${rem(-22)};
  --float-rotate: 2deg;
  animation-duration: 5.5s;
  animation-delay: 0.8s;
`

const FloatingImageBottomLeft = styled(BaseFloatingImage)`
  width: ${rem(169)};
  height: ${rem(169)};
  bottom: ${rem(82)};
  left: ${rem(118)};
  --float-y: ${rem(-18)};
  --float-rotate: 3deg;
  animation-duration: 4.5s;
  animation-delay: 1s;
`

const FloatingImageTopRight = styled(BaseFloatingImage)`
  width: ${rem(171)};
  height: ${rem(171)};
  top: ${rem(29)};
  right: ${rem(97)};
  --float-y: ${rem(-15)};
  --float-rotate: 2deg;
  animation-duration: 4s;
  animation-delay: 0s;
`

const FloatingImageRight = styled(BaseFloatingImage)`
  width: ${rem(234)};
  height: ${rem(234)};
  top: calc(50% - ${rem(234 / 2)});
  right: ${rem(-20)};
  --float-y: ${rem(-20)};
  --float-rotate: -2deg;
  animation-duration: 5s;
  animation-delay: 0.5s;
`

const FloatingImageBottomRight = styled(BaseFloatingImage)`
  width: ${rem(169)};
  height: ${rem(169)};
  bottom: ${rem(22)};
  right: ${rem(84)};
  --float-y: ${rem(-16)};
  --float-rotate: -3deg;
  animation-duration: 4.2s;
  animation-delay: 1.5s;
`

const IMAGE_TOP_LEFT = getImageUrl('ug4tob1vwqy2wy7lu08c', { width: 240, aspectRatio: '1:1' })
const IMAGE_LEFT = getImageUrl('j6awaoj85focmvct1nnu', { width: 458, aspectRatio: '1:1' })
const IMAGE_BOTTOM_LEFT = getImageUrl('ikdsdj7afstj03xqz2jr', { width: 338, aspectRatio: '1:1' })
const IMAGE_TOP_RIGHT = getImageUrl('mcgnbxdcikgz60ni7evj', { width: 342, aspectRatio: '1:1' })
const IMAGE_RIGHT = getImageUrl('fqlnlei5o93e83o13cpn', { width: 468, aspectRatio: '1:1' })
const IMAGE_BOTTOM_RIGHT = getImageUrl('4ktyrsdowy8tgii8ynb', { width: 338, aspectRatio: '1:1' })

interface Props {
  className?: string
}

function ChatLandingFloatingImages({ className }: Props) {
  return (
    <FloatingImagesContainer className={className}>
      <FloatingImageTopLeft>
        <ImageElement src={IMAGE_TOP_LEFT} alt="" loading="lazy" />
      </FloatingImageTopLeft>
      <FloatingImageLeft>
        <ImageElement src={IMAGE_LEFT} alt="" loading="lazy" />
      </FloatingImageLeft>
      <FloatingImageBottomLeft>
        <ImageElement src={IMAGE_BOTTOM_LEFT} alt="" loading="lazy" />
      </FloatingImageBottomLeft>
      <FloatingImageTopRight>
        <ImageElement src={IMAGE_TOP_RIGHT} alt="" loading="lazy" />
      </FloatingImageTopRight>
      <FloatingImageRight>
        <ImageElement src={IMAGE_RIGHT} alt="" loading="lazy" />
      </FloatingImageRight>
      <FloatingImageBottomRight>
        <ImageElement src={IMAGE_BOTTOM_RIGHT} alt="" loading="lazy" />
      </FloatingImageBottomRight>
    </FloatingImagesContainer>
  )
}

export default ChatLandingFloatingImages
